import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { Form } from "@talladega/components";
import { ChangeEvent } from "react";
import { translate } from "@talladega/helpers";
import { VehicleTransmissionType } from "@modules/vehicle/types/Vehicle";
import {
  FilterAction,
  FilterActions,
  FilterKeys,
  TransmissionFilter,
  VehicleFilter,
} from "../types/vehicleFilter";
import FilterDisclosure from "./FilterDisclosure";

type Props = {
  transmissionTypes: VehicleTransmissionType[];
  onUpdate(filterAction: FilterAction): void;
  vehicleFilters: VehicleFilter[];
};

const VehicleTransmissionFilter = ({
  transmissionTypes,
  onUpdate,
  vehicleFilters,
}: Props) => {
  const { t } = useTranslation(["common"]);
  const router = useRouter();
  const locale = router.locale || "";

  const transmissionFilter = vehicleFilters.filter(
    (f) => f.key === FilterKeys.Transmission
  ) as TransmissionFilter[];

  const selectedTransmissions = transmissionFilter.map((f) => f.state);

  const handleCheckChange = (
    event: ChangeEvent<HTMLInputElement>,
    displayTransmission: VehicleTransmissionType
  ) => {
    if (event.target.checked) {
      onUpdate({
        type: FilterActions.AddTransmissionFilter,
        payload: {
          id: displayTransmission.id.toString(),
          name: displayTransmission.name,
        },
      });
    } else {
      onUpdate({
        type: FilterActions.RemoveByIdAndType,
        payload: {
          type: FilterKeys.Transmission,
          id: displayTransmission.id.toString(),
        },
      });
    }
  };

  return (
    <FilterDisclosure
      headerText={t("common:transmission")}
      active={selectedTransmissions.length > 0}
    >
      <ul className="body-3">
        {transmissionTypes &&
          transmissionTypes.map((tt) => (
            <li key={tt.id}>
              <Form.Checkbox
                id={`display-transmission-${tt.id}`}
                checkboxStyle="bordered"
                label={translate(tt.name, locale)}
                onChange={(event) => handleCheckChange(event, tt)}
                checked={
                  selectedTransmissions
                    .map((st) => st.id)
                    .indexOf(tt.id.toString()) > -1
                }
              />
            </li>
          ))}
      </ul>
    </FilterDisclosure>
  );
};

export default VehicleTransmissionFilter;
